export const PENDING_SCROLL_TARGET_KEY = 'pending-scroll-target';

export const setPendingScrollTarget = (targetId) => {
  if (typeof window === 'undefined' || !targetId) return;
  window.sessionStorage.setItem(PENDING_SCROLL_TARGET_KEY, targetId);
};

export const consumePendingScrollTarget = () => {
  if (typeof window === 'undefined') return null;
  const target = window.sessionStorage.getItem(PENDING_SCROLL_TARGET_KEY);
  if (target) {
    window.sessionStorage.removeItem(PENDING_SCROLL_TARGET_KEY);
    return target;
  }
  return null;
};
